<template>
	<div class="container">
		<div class="g-p-30">
			<!--  tab1  -->
			<el-tabs v-model="tabNow" @tab-click="tabChange">
				<el-tab-pane label="我的投递" name="0"></el-tab-pane>
				<el-tab-pane label="收藏职位" name="1"></el-tab-pane>
			</el-tabs>

			<!--  我的投递  -->
			<div v-if="tabNow === '0'">
				<!--  tab2  -->
				<div class="g-flex">
					<div class="g-m-t-20 g-flex tab2 g-row-between">
						<div class="tab-item" :class="{'active-row':subTabIndex === 1}" @click="changeSubTab(1)">
							全部
						</div>
						<div class="tab-item" :class="{'active-row':subTabIndex === 2}" @click="changeSubTab(2)">
							被邀请({{delivery2Total}})
						</div>
					</div>
				</div>
				<!--  全部列表|被邀请  -->
				<!--  筛选被邀请只用重新请求接口并带上筛选条件即可  -->
				<div class="list-item g-m-t-20" v-for="(item,index) in dataList1" :key="index">
					<div class="g-p-20">
						<div class="g-flex g-row-between">
							<p class="g-font-20 g-font-weight-5 "
								:class="{'green-text': item.status !== 3,'yellow-text': item.status ===3}">
								{{ statusText(item) }}
							</p>
							<p class="remark-text g-font-14">{{ '投递时间：' + item.createTime }}</p>
						</div>
						<div class="info-box g-m-t-20">
							<div class="g-p-20">
								<div class="g-flex">
									<p class="g-font-18 g-font-weight-5">{{ item.demand.postName }}</p>
									<p class="g-m-l-20 remark-text g-font-14">{{ item.demand.qualifications }}|{{ item.demand.workYear }}年经验|{{ item.demand.num }}人</p>
									<p class="g-flex-right yellow-text g-font-weight-5">{{ item.demand.salary }}</p>
								</div>
								<div class="g-flex g-m-t-20">
									<img :src="item.demand.avatar?item.demand.avatar:require('@/assets/examples/02.png')" class="company-img" alt="">
									<p class="g-m-l-10 g-font-14">{{ item.demand.clinicName }}</p>
									<p class="remark-text g-m-l-30">{{ item.demand.cityName }}{{ item.demand.countyName }}</p>
									<div class="submit-btn g-flex-right" @click="doCheck(item)"
										v-if="item.status==4||item.status==5||item.status==6||item.status==2||item.status==1">
										<span v-if="item.status==4||item.status==5||item.status==6">查看面试信息</span>
										<span v-if="item.status==2||item.status==1">查看面试邀请</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--  分页  -->
				<div class="g-flex g-row-center g-m-t-30">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="deliveryParams.current" :page-sizes="[10, 20, 30, 40]" :page-size="deliveryParams.size"
						layout="total, sizes, prev, pager, next, jumper" :total="deliveryTotal">
					</el-pagination>
				</div>
			</div>

			<!--  收藏职位  -->
			<div v-if="tabNow === '1'">
				<div class="info-box g-m-t-20" v-for="(item,index) in dataList2" :key="index">
					<div class="g-p-20">
						<div class="g-flex">
							<p class="g-font-18 g-font-weight-5">{{ item.postName }}</p>
							<p class="g-m-l-20 remark-text g-font-14">{{ item.qualifications }}|{{ item.workYear }}年经验|{{ item.num }}人</p>
							<p class="g-flex-right yellow-text g-font-weight-5">{{ item.salary }}</p>
						</div>
						<div class="g-flex g-m-t-20">
							<img :src="item.avatar?item.avatar:require('@/assets/examples/02.png')" class="company-img" alt="">
							<p class="g-m-l-10 g-font-14">{{ item.clinicName }}</p>
							<p class="remark-text g-m-l-30">{{ item.cityName }}</p>
							<div class="g-flex g-flex-right">
								<div class="btn" @click="cancelCollect(item.collectId)" v-if="item.collectId!=-1">取消收藏</div>
								<!--  未收藏过的才显示收藏职位  -->
								<div class="submit-btn g-m-l-20" @click="doCollect(index)" v-if="item.resumeId==-1">投递简历</div>
							</div>
						</div>
					</div>
				</div>
				<!--  分页  -->
				<div class="g-flex g-row-center g-m-t-30">
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
						:current-page="collectParams.current" :page-sizes="[10, 20, 30, 40]" :page-size="collectParams.size"
						layout="total, sizes, prev, pager, next, jumper" :total="collectTotal">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--  查看面试邀请  -->
		<el-dialog :visible.sync="show" class="popup1" width="31%">
			<div class="g-text-center g-p-b-15 border-bottom g-font-20 g-weight-font">
				面试邀请
			</div>
			<p class="g-m-t-20 remark-text g-font-16">
				面试岗位
			</p>
			<div class="info-box g-m-t-10" v-if="selected">
				<div class="g-p-20">
					<div class="g-flex g-row-between">
						<p class="g-font-18 main-text g-weight-font">{{ selected.demand.postName}}</p>
						<p class="g-font-16 yellow-text g-weight-font">{{ selected.demand.salary }}</p>
					</div>
					<div class="g-flex g-row-between g-m-t-20">
						<div class="g-flex g-full-width">
							<p class=" g-font-14 sub-text">{{ selected.demand.clinicName }}</p>
							<!--<p class="g-m-l-36 remark-text g-font-14">
								{{ selected.demand.requirements}}
							</p>-->
							<p class="g-flex-right main-text g-font-14">{{ selected.demand.cityName }}{{ selected.demand.countyName }}</p>
						</div>
					</div>
				</div>
			</div>
			<div v-if="selected.interview">
				<div class="g-m-t-15 g-flex g-font-16">
					<p class="label remark-text ">联系人</p>
					<p class="g-m-l-30 main-text">{{selected.interview.orgContacts}}</p>
				</div>
				<div class="g-m-t-15 g-flex g-font-16">
					<p class="label remark-text ">联系电话</p>
					<p class="g-m-l-30 main-text">{{selected.interview.orgMobile}}</p>
				</div>
				<div class="g-m-t-15 g-flex g-font-16">
					<p class="label remark-text ">面试时间</p>
					<p class="g-m-l-30 main-text">{{selected.interview.interviewTime}}</p>
				</div>
				<div class="g-m-t-15 g-flex g-font-16">
					<p class="label remark-text ">面试地点</p>
					<p class="g-m-l-30 main-text">{{selected.interview.orgAddress}}</p>
				</div>
				<div class="g-flex g-row-center g-m-t-30" v-if="selected.status===1">
					<div class="btn2" @click="show = false">再想想</div>
					<div class="btn2 g-m-l-20" @click="doRefuse(selected.id)">拒绝邀请</div>
					<div class="submit-btn g-m-l-20" @click="doAccept(selected.id)">接受面试</div>
				</div>
			</div>
			
		</el-dialog>
		<!--  投递成功  -->
		<message-popup ref="popup1" :showCancel="false" confirmText="知道了" @submit="doSubmit">
			<div class="g-text-center">
				<p class="g-m-t-10 main-text g-font-20">投递成功了!</p>
				<p class="g-m-t-20 remark-text g-font-14">已成功为您投递简历，请留意站内消息。</p>
			</div>
		</message-popup>
		<!--  取消收藏成功  -->
		<message-popup ref="popup2" :showCancel="false" confirmText="知道了" @submit="doSubmit">
			<div class="g-text-center g-m-t-40">
				<p class="g-m-t-10 main-text g-font-20">取消成功!</p>
				<p class="g-m-t-20 remark-text g-font-14">已取消收藏该职位信息</p>
			</div>
		</message-popup>

	</div>
</template>

<script>
	import messagePopup from "@/components/message-popup";
	import {
		getDeliveryList,
		resumestatusorgDetail,
		sendResumeUpdate,
		pageCollection,
		deleteCollection,
		sendResume
	} from "@/api/job.js"
	export default {
		name: "send-collection",
		components: {
			messagePopup
		},
		data() {
			return {
				tabNow: '0',
				show: false,
				subTabIndex: 1, //子tab下标
				currentPage: 1, //分页
				currentPage2: 1, //分页
				dataList1: [],
				dataList2: [],
				selected: '',
				deliveryParams:{
					current: 1,
					size: 10,
					queryType:1
				},
				collectParams:{
					current: 1,
					size: 10
				},
				deliveryTotal:0,
				delivery2Total:0,
				collectTotal:0,
				curlDetail:{}
			}
		},
		watch: {
			deliveryParams:{
				handler(n, o) {
					this.getDeliveryList()
				},
				deep: true
			}
		},
		mounted(){
			this.getDeliveryList()
			this.getDelivery2Total()
			this.getPageCollection()
		},
		computed: {
			statusText : function() {
				return ele =>{
					let text = '';
					let status = ele.status;
					let isView = ele.isView;
					if(status===0){
						if(isView=='1'){
							return '已送达'
						} else if(isView=='2'){
							return '已查看'
						}
					} else if(status===1){
						return '待接受面试'
					} else if(status===2){
						return '待面试'
					} else if(status===3){
						return '已拒绝'
					} else if(status===4||status===5||status===6){
						return '已面试'
					}
					return text;
				}
			}
		},
		methods: {
			//收藏列表
			getPageCollection(){
				pageCollection(this.collectParams).then(res=>{
					this.collectTotal=res.total
					this.dataList2=res.records
				})
			},
			//邀请详情
			resumestatusorgDetail(id){
				resumestatusorgDetail({id:id}).then(res=>{
					this.selected.interview=res;
					this.$forceUpdate()
				})
			},
			//被邀请数量
			getDelivery2Total(){
				if(this.$store.state.userInfo.resumeId==-1){//没有简历调接口会报错
					return false;
				}
				getDeliveryList({
					current: 1,
					size: 10,
					queryType:0
				}).then(res=>{
					
					this.delivery2Total=res.total
				})
			},
			//投递记录
			getDeliveryList(){
				if(this.$store.state.userInfo.resumeId==-1){//没有简历调接口会报错
					return false;
				}
				getDeliveryList(this.deliveryParams).then(res=>{
					this.dataList1=res.records
					this.deliveryTotal=res.total
					if(this.deliveryParams.queryType==0){
						this.delivery2Total=res.total;
					}
					
				})
			},
			// tab切换
			tabChange(tab) {
				this.tabNow = tab.index;
			},
			// 子tab切换
			changeSubTab(index) {
				console.log(index)
				this.subTabIndex = index;
				this.deliveryParams.queryType=index===1?1:0
			},
			// 我的投递 页数切换
			handleSizeChange(val) {
				this.deliveryParams.size=val
				this.getDeliveryList()
				console.log(`每页 ${val} 条`);
			},
			// 我的投递 当前页切换
			handleCurrentChange(val) {
				this.deliveryParams.current=val
				this.getDeliveryList()
				console.log(`当前页: ${val}`);
			},
			// 我的收藏 页数切换
			handleSizeChange2(val) {
				this.collectParams.size=val
				this.getPageCollection()
				console.log(`每页 ${val} 条`);
			},
			// 我的收藏 当前页切换
			handleCurrentChange2(val) {
				this.collectParams.current=val
				this.getPageCollection()
				console.log(`当前页: ${val}`);
			},
			// 投递弹窗提交
			doSubmit() {
				
				this.$refs.popup1.close();
				
			},
			// 取消收藏
			cancelCollect(id) {
				deleteCollection({
					id:id
				}).then(res=>{
					this.getPageCollection()
					this.$refs.popup2.open();
				})
				
			},
			// 投递简历
			doCollect(index) {
				if(this.$store.state.userInfo.resumeId==-1) {
					this.$message.warning('请先完善个人简历信息');
					this.$router.push({name:'mine',query:{menuIndex:2}});
				} else {
					let params={
						orgId:this.dataList2[index].clinicId,
						orgName:this.dataList2[index].clinicName,
						employPostId:this.dataList2[index].postId,
						employPostName:this.dataList2[index].postName,
						type:0,
						status: 0
					}
					sendResume(params).then(res=>{
						this.getPageCollection()
						this.$refs.popup1.open();
					})
				}
			},
			// 查看面试邀请
			doCheck(val) {
				this.selected = val
				this.show = true
				if(this.selected!==0){
					this.resumestatusorgDetail(val.id);
				}
				
			},
			//  拒绝面试
			doRefuse(id) {
				// todo...
				sendResumeUpdate({
					id:id,
					status:3
				}).then(res=>{
					this.show=false;
					this.getDeliveryList()
					
				})
			},
			//  接受面试
			doAccept(id) {
				sendResumeUpdate({
					id:id,
					status:2
				}).then(res=>{
					this.show=false;
					this.getDeliveryList()
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		background: #ffffff;
		border-radius: 5px;
	}

	::v-deep .el-tabs__item.is-active {
		color: #333;
		font-size: 20px;
		font-weight: 500;
	}

	::v-deep .el-tabs__item {
		color: #999;
		font-size: 20px;
		font-weight: 500;
	}

	.tab2 {
		background: #e9f2ff;
		border-radius: 15px;

		.tab-item {
			padding: 5px 21px;
			color: #407aff;
			cursor: pointer;
		}

		.active-row {
			border-radius: 15px;
			background: #407aff;
			color: #fff;
		}
	}

	.list-item {
		background: #fff;
		border-radius: 5px;
		box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);
	}

	.info-box {
		background: #f6f6f8;
		border-radius: 5px;

		.company-img {
			width: 30px;
			height: 30px;
		}
	}

	.submit-btn {
		padding: 6px 18px;
		margin-right: 0;
	}

	::v-deep .el-dialog__header {
		padding: 0 !important;
	}

	.btn2 {
		background: #f6f6f8;
		border-radius: 5px;
		padding: 6px 18px;
		color: #407aff;
		cursor: pointer;
	}

	.btn {
		cursor: pointer;
		background: #fff;
		color: #407aff;
		padding: 6px 18px;
	}
</style>
